export const OFFERS_LOGIN_DARWIN_TEST = {
  CONTROL: 'control',
  TEST: 'test',
};
